import * as yup from "yup";

export const registerTalentValidationSchema = yup.object().shape({
  username: yup
    .string()
    .required("Talent name is required")
    .min(2, "Talent name must be at least 2 characters"),
  categories: yup.string().required("Category is required"),
  portfolio_links: yup.array().of(yup.string().url("Portfolio link must be a valid URL")),
  social_links: yup.array().of(yup.string().url("Social link must be a valid URL")),
});
